import { useMediaQuery, useTheme } from '@mui/material';
import React, { ReactElement } from 'react';
import { OrganizationClickCardSkeleton } from './OrganizationClickCardSkeleton';

export const OrganizationClickCardSkeletons = (): ReactElement => {
  const theme = useTheme();
  const isLargeUp = useMediaQuery(theme.breakpoints.up('lg'));
  const isSmallUp = useMediaQuery(theme.breakpoints.up('sm'));

  const numberOfItems = isLargeUp ? 8 : isSmallUp ? 4 : 3;

  return (
    <>
      {Array(numberOfItems)
        .fill(undefined)
        .map((_, index) => (
          <React.Fragment key={index}>
            <OrganizationClickCardSkeleton />
          </React.Fragment>
        ))}
    </>
  );
};
